import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  FormControl,
  Input,
  FormLabel,
  Divider,
  Checkbox,
  Tooltip,
  Icon,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import "./EditFieldStyles.css";
import AddChoiceIcon from "../Icons/AddChoices";
import RemoveChoiceIcon from "../Icons/RemoveChoices";
import EditFieldDragIcon from "../Icons/EditFieldDrag";

const CheckBox = ({ field, handleOnChange, addChoice, removeChoice }) => {
  const styleClasses = field.styleClasses.length
    ? field.styleClasses.join(" ")
    : "";
  return (
    <Box mt="16px" w="380px" h="333.93">
      <FormControl mb="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Label
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={field.label}
          placeholder="Enter label"
          onChange={(e) => handleOnChange(e, "label")}
        />
        <Checkbox
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          mt="12px"
          isChecked={field.showLabel}
          onChange={(e) => handleOnChange(e, "showLabel")}
        >
          Show label
        </Checkbox>
      </FormControl>
      <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
        Choices
      </FormLabel>
      {field.choices.map((element, index) => (
        <div className="choicesBlock" key={index} style={{ display: "flex" }}>
          <div style={{ alignSelf: "center" }}>
            <EditFieldDragIcon />
          </div>
          <Checkbox
            fontSize="13px"
            className="editFieldCheckBox"
            isChecked={element.checked}
            id={element.id}
            onChange={(e) =>
              handleOnChange(e, "choices", {
                addChoiceValue: "addChoiceValue",
              })
            }
          ></Checkbox>
          {`  `}
          <Input
            type="text"
            placeholder="Enter choice label"
            width="264px"
            h="32px"
            border="1px"
            borderStyle="solid"
            borderColor="#CFD7DF"
            borderRadius="4px"
            name={element.name}
            id={element.id}
            ml="8px"
            mr="8px"
            value={element.value}
            onChange={(e) =>
              handleOnChange(e, "choices", {
                checkBox: "checkBox",
                addChoiceValue: "addChoiceValue",
              })
            }
          />
          {`   `}
          <div
            width="20px"
            height="20px"
            style={{ alignSelf: "center" }}
            onClick={() => addChoice("choices", "checkBox")}
          >
            <AddChoiceIcon />
          </div>
          {`   `}
          <div
            width="20px"
            height="20px"
            style={{ alignSelf: "center", marginLeft: "8px" }}
            onClick={() => (field.choices.length-1) !=0 && removeChoice(element.id, "choices", "checkBox")}
          >
            <RemoveChoiceIcon />
          </div>
        </div>
      ))}
      {`  `}
      <Divider mt="24px" />
      <FormControl mt="24px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Form css class{" "}
          <Tooltip
            label="Enter multiple css classes separated by space"
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={styleClasses}
          placeholder="Enter css class name"
          onChange={(e) => handleOnChange(e, "styleClasses")}
        />
      </FormControl>
    </Box>
  );
};

CheckBox.propTypes = {
  field: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

export default CheckBox;
